import ServicePageTemplate from "@/pages/services/components/ServicePageTemplate";
import { getServiceDetail } from "@/mocks/services";

export default function HouseShiftingPage() {
  const detail = getServiceDetail("house-shifting");
  if (!detail) return null;
  return <ServicePageTemplate detail={detail} />;
}